import styled from '@emotion/styled';
import React from 'react';

import { useWorkspaceId } from '@/hooks/router';
import { useGetJobopeningCareers } from '@/queries/jobopenings/queries';
import { CareersAddJobOpeningButton } from './careers-add-job-opening-button';
import { CareersJobOpeningListItem } from './careers-job-opening-list-item';

export const CareersJobOpeningList = () => {
  const workspaceId = useWorkspaceId();
  const query = useGetJobopeningCareers(Number(workspaceId));

  return (
    <>
      <Header>
        <h3>Job Openings ({query.data?.length || 0})</h3>
        {query.data?.length && query.data?.length > 0 && (
          <CareersAddJobOpeningButton />
        )}
      </Header>
      {!(query.data?.length && query.data?.length > 0) ? (
        <EmptyContainer>
          No job openings published yet
          <CareersAddJobOpeningButton />
        </EmptyContainer>
      ) : (
        <Content>
          {query.data?.map((jobopening) => (
            <CareersJobOpeningListItem
              key={jobopening.openingId}
              jobOpening={jobopening}
            />
          ))}
        </Content>
      )}
    </>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const EmptyContainer = styled.div`
  height: 108px;
  width: 668px;
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.purple['2.5']};
  color: ${(props) => props.theme.colors.purple[60]};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 36px;
`;
